import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { ToastContainer, getStyled, SFStack, useWindowSize } from "@sf-core";
import SFTheme from "@sf-core/theme";
import HeaderLayout from "../../containers/headerLayout";
import SideMenuLayout from "../../containers/sideMenuLayout";
import NotificationLayout from "../../containers/notificationLayout";
import Box from "@mui/material/Box";

const { styled } = getStyled();
const drawerWidth = 110;

const StyledStackContainer = styled(SFStack)(({ theme, open }) => ({
  flex: 1,
}));

const StyledStack = styled(SFStack, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: `calc(100% - ${drawerWidth}px)`,
  minHeight: "100vh",
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: 0,

  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

const RoutesWrapper = ({ children, routes }) => {
  const [menuOpen, setMenuOpen] = useState(true);
  const [forceMenuClosed, setForceMenuClosed] = useState(false);
  const windowSize = useWindowSize();
  const { pathname } = useLocation();

  useEffect(() => {
    if (windowSize.width <= SFTheme().breakpoints.values.md) {
      setForceMenuClosed(true);
      if (!menuOpen) setMenuOpen(true);
    } else {
      setForceMenuClosed(false);
    }
  }, [windowSize]);

  useEffect(() => {
    //scroll to top when location is changing
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Box sx={{ display: "flex" }}>
      <SideMenuLayout
        routes={routes}
        onMenuOpen={(o) => setMenuOpen(o)}
        menuOpen={menuOpen && !forceMenuClosed}
      />
      <NotificationLayout />
      <StyledStack open={menuOpen && !forceMenuClosed}>
        <HeaderLayout
          routes={routes}
          menuOpen={menuOpen && !forceMenuClosed}
          onMenuOpen={(o) => setMenuOpen(o)}
        />
        {/* additional side drawer that renders next to sidemenu  */}
        <div id="sideDrawerRoot" />
        <StyledStackContainer width="100%">
          <div id="stepperRoot" />
          <div id="tabbedLayoutRoot" />
          {/* used this as pointer in scroll to top btn  */}
          <div className="scroll-to-top-el"></div>
          {children}
        </StyledStackContainer>
        <ToastContainer />
      </StyledStack>
    </Box>
  );
};

export default RoutesWrapper;
